<template lang='pug'>
v-app(v-if='hasAdmin ? usersForAdmin : true')
  div(v-if='hasAdminOrOrgAdmin')
    v-row
      v-col(cols='3')
        v-text-field(v-model='name' label='組織名' hide-details :rules='[value => value ? true : false]' density='comfortable')
      v-col(cols='5')
        v-text-field(v-model='description' label='説明文' hide-details density='comfortable')
      v-col.select-target-root-admin-org-for-new-org(cols='2' v-if='!hasAdmin')
        v-select(v-model='selectedRootAdminOrgId' :items='currentRootAdminOrgs' label='追加先ルート管理組織' hide-details density='comfortable' :menu-props="{ attach: '.select-target-root-admin-org-for-new-org' }")
      v-col(cols='2')
        v-btn.mt-2(block prepend-icon='mdi-plus' @click='createOrganization' :disabled='!name' color='primary') 新規作成
      v-col(cols='2' v-if='hasAdmin')
        v-dialog(attach='true' max-width='800')
          template(v-slot:activator='{ props: activatorProps }')
            v-btn.mt-2(block prepend-icon='mdi-table-account' v-bind='activatorProps' color='primary') CSV管理
          template(v-slot:default='{ isActive }')
            v-card.my-3
              v-card-text
                .h5 登録情報ダウンロード
                v-divider.mt-2.mb-4
                .d-flex.align-center
                  v-btn.ms-2(size='small' @click='downloadOrganizations("UTF-8")')
                    v-icon.me-2(icon='mdi-download')
                    | UTF-8形式
                  v-btn.ms-2(size='small' @click='downloadOrganizations("SJIS")')
                    v-icon.me-2(icon='mdi-download')
                    | Shift-JIS形式
                  span.ms-4 ：ユーザー情報一覧をダウンロード
                .d-flex.align-center.my-4
                  v-btn.ms-2(size='small' @click='downloadOrganizationTable("UTF-8")')
                    v-icon.me-2(icon='mdi-download')
                    | UTF-8形式
                  v-btn.ms-2(size='small' @click='downloadOrganizationTable("SJIS")')
                    v-icon.me-2(icon='mdi-download')
                    | Shift-JIS形式
                  span.ms-4 ：組織情報一覧をダウンロード

                .h5.mt-6 ユーザー情報一括変更
                v-divider.mt-2.mb-4
                v-row
                  v-col
                    .d-flex.align-center
                      v-btn.ms-2(size='small' @click='downloadPersonnelChanges("UTF-8")')
                        v-icon.me-2(icon='mdi-download')
                        | UTF-8形式
                      v-btn.ms-2(size='small' @click='downloadPersonnelChanges("SJIS")')
                        v-icon.me-2(icon='mdi-download')
                        | Shift-JIS形式
                      span.ms-4 ：ユーザー情報変更用のデータをダウンロード
                v-row.mb-2
                  v-col.pt-0(cols='12')
                    v-file-input(density='compact' v-model='personnelChangesFile' label='人事異動用のデータ' accept='.csv' hide-details)
                    v-btn.mt-3(@click='uploadPersonnelChanges' :disabled='!personnelChangesFile')
                      v-icon.me-2(icon='mdi-application-import')
                      | インポート開始

                .h5.mt-2 ユーザー一括登録
                v-divider.mt-2.mb-4
                v-row
                  v-col
                    .d-flex.align-center
                      v-btn.ms-2(size='small' @click='downloadRegistrationTemplate("UTF-8")')
                        v-icon.me-2(icon='mdi-download')
                        | UTF-8形式
                      v-btn.ms-2(size='small' @click='downloadRegistrationTemplate("SJIS")')
                        v-icon.me-2(icon='mdi-download')
                        | Shift-JIS形式
                      span.ms-4 ：ユーザー一括登録用データをダウンロード
                v-row
                  v-col.pt-0(cols='12')
                    v-file-input(density='compact' v-model='registrationFile' label='新規ユーザー登録用のデータ' accept='.csv' hide-details)
                    v-btn.mt-3(@click='uploadRegistration' :disabled='!registrationFile')
                      v-icon.me-2(icon='mdi-application-import')
                      | インポート開始
                span.my-2(v-if='uploadErrorMessage' style='color: red') {{ uploadErrorMessage }}

              template(v-slot:actions)
                v-btn.ms-auto(color='grey-darken-2' prepend-icon='mdi-close' text='閉じる', @click='isActive.value = false')

    .mt-1(v-if='!dialog && errorMessage' style='color: red') {{ errorMessage }}

    v-switch.mt-4(color='primary' label='組織のドラッグ操作をロックする' true-icon='mdi-lock' false-icon='mdi-lock-open-variant' hide-details inset density='compact' v-model='lockDraggable')

  Draggable.mt-2(
    treeLine
    :key='treeKey'
    v-model='organizations'
    :each-draggable='checkDraggable' :each-droppable='checkDroppable' :disableDrag='lockDraggable' :disableDrop='lockDraggable'
    @change='updateRelationships'
    @before-drag-start='handleDragStart'
  )
    template(#default='{ node, stat }')
      .py-2
        v-card.w-100(color='#edebfa' variant='elevated' :class="{ 'undraggable': !node.admin }")
          v-card-text.py-0.px-2.d-flex.flex-column
            .d-flex.justify-space-between.w-100
              .d-flex.align-center
                OpenIcon(v-if='stat.children.length' :open='stat.open' class='mtl-mr mx-1' @click.native='stat.open = !stat.open')
                .d-flex
                v-icon(v-if='checkDraggable(stat) && !lockDraggable' icon='mdi-drag')
                v-icon-btn.ms-1.me-1(v-if='!hasAdmin' :icon='node.current_user_ancestor_role === "org_admin" ? "mdi-cog" : node.current_user_ancestor_role === "org_editor" ? "mdi-pencil" : "mdi-eye"' size='small' variant="tonal")
                .d-flex.ms-1 {{ node.name }}
              .d-flex
                v-btn(variant='text' size='small' color='secondary' icon='mdi-eye' :href='`/organizations/${node.id}`')
                v-divider.my-2(vertical color='primary')
                v-btn(v-if='node.admin' variant='text' size='small' color='secondary' icon='mdi-square-edit-outline' @click='showDialog(node.id)')
                v-btn(variant='text' size='small' color='secondary' icon='mdi-information-outline' @click='stat.expand = !stat.expand')
                .d-flex.align-center
                  v-chip.me-2(density='compact' prepend-icon='mdi-account-multiple')
                    | {{ node.users.length }}
                  v-chip(density='compact' prepend-icon='mdi-cube-scan')
                    | {{ node.showcases.length }}
          .d-flex.expand-content
              v-expand-transition
                //- NOTE: v-containerをtransitionさせると動作がかなり重くなるのでv-rowを調整する方針に変更した
                v-row.px-3(v-if='stat.expand')
                  v-col.p-3(cols='12' lg='6')
                    .text-subtitle-2.text-center 所属ユーザー
                    v-divider.mt-1.mb-2
                    v-chip.me-2.mb-2(v-for='user in node.users' density='comfortable' :prepend-icon='user.role === "org_admin" ? "mdi-cog" : user.role === "org_editor" ? "mdi-pencil" : "mdi-eye"')
                      | {{ user.name }}
                  v-col.p-3(cols='12' lg='6')
                    .text-subtitle-2.text-center {{ `所属${props.showcaseAlias}` }}
                    v-divider.mt-1.mb-2
                    v-chip.me-2.mb-2(v-for='showcase in node.showcases' prepend-icon='mdi-open-in-new' :href='`/showcases/${showcase.id}`' target='_blank' density='comfortable')
                      | {{ showcase.name }}

  v-dialog(v-model='dialog', width='90%' max-height='90%' scrollable persistent :attach='true')
    v-card(v-if='selectedOrganization' title='組織編集')
      v-divider
      v-card-text
        template(v-if='selectedOrganization.admin')
          v-text-field(v-model='selectedOrganization.name' label='組織名' hide-details)
        template(v-else)
          h6 組織名
          p {{ selectedOrganization.name }}
        v-text-field.mt-3(v-model='selectedOrganization.description' label='説明文' hide-details)
        span(v-if='dialog && errorMessage' style='color: red') {{ errorMessage }}

        v-tabs.mt-5(v-model='tab' fixed-tabs)
          v-tab(value='tab-members' text='メンバー')
          v-tab(value='tab-showcases' :text='props.showcaseAlias')

        v-tabs-window(v-model='tab')
          v-tabs-window-item(value='tab-members')
            v-card
              v-card-text
                h6 メンバー一覧

                v-table.mt-3(density='comfortable' striped='even' fixed-header)
                  thead
                    tr
                      th ID
                      th 名前
                      th 権限
                  tbody
                    template(v-for='user in selectedOrganization.users')
                      tr(v-if='user.role !== "none" || user.ancestor_role !== "none"')
                        td {{ user.id }}
                        td {{ user.name }}
                        td {{ getRoleName(user.role, user.ancestor_role) }}

                v-expansion-panels.mt-5(v-model='panels')
                  v-expansion-panel
                    v-expansion-panel-title メンバー編集
                    v-expansion-panel-text
                      v-data-table(v-model='selectedUserIds' :headers='headersForMember' :items='currentOrgRootSubtreeShowcasesAndUsers.users' density='comfortable' striped='even' show-select fixed-heaeder @update:modelValue="onSelectedUserIdsChange")
                        template(v-slot:item.data-table-select='{ internalItem, isSelected, toggleSelect }')
                          v-checkbox-btn(
                            :model-value='isSelected(internalItem)'
                            :disabled='!hasAdmin && currentUserId === internalItem.raw.id && internalItem.raw.role === "org_admin"'
                            @update:model-value='toggleSelect(internalItem)'
                          )
                        template(v-slot:item.role='{ item }')
                          div(v-if='item.ancestor_role !== "none"')
                            p.my-2 {{ `親組織の${getRoleName(item.ancestor_role)}` }}
                            v-select.mt-0.mb-2(v-if='selectedUserIds.includes(item.id)' v-model='usersRoleModel(item.id).value' :items='abilityList' density='compact' label='権限' hide-details)
                          div(v-else-if='!hasAdmin && currentUserId === item.id && item.role === "org_admin"')
                            p.my-2 自身が管理者
                          div(v-else-if='!selectedUserIds.includes(item.id)')
                            p.my-2 未所属
                          div(v-else)
                            v-select.my-2(v-model='usersRoleModel(item.id).value' :items='abilityList' density='compact' label='権限' hide-details)

          v-tabs-window-item(value='tab-showcases')
            v-card
              v-card-text
                h6 {{ `${props.showcaseAlias}一覧` }}

                v-row.mt-3.border-bottom
                  v-col(cols='2') ID
                  v-col(cols='5') SID
                  v-col(cols='5') 名前
                v-row.border-bottom(v-for='showcase in selectedOrganization.showcases')
                  v-col(cols='2') {{ showcase.id }}
                  v-col(cols='5') {{ showcase.sid }}
                  v-col(cols='5') {{ showcase.name }}

                v-expansion-panels.mt-5(v-model='panels')
                  v-expansion-panel
                    v-expansion-panel-title {{ `${props.showcaseAlias}編集` }}
                    v-expansion-panel-text
                      v-data-table(v-model='selectedShowcaseIds' :headers='headersForShowcase' :items='currentOrgRootSubtreeShowcasesAndUsers.showcases' item-value='id' density='comfortable' striped='even' show-select fixed-heaeder @update:modelValue="onSelectedShowcaseIdsChange")

      template(v-slot:actions)
        v-btn(v-if='hasAdmin || selectedOrganization.deletable' color='red' prepend-icon='mdi-trash-can' text='削除', @click='deleteOrganization')
        v-btn.ms-auto(prepend-icon='mdi-check' text='OK', @click='closeDialog')
</template>

<script setup>
import { VIconBtn } from 'vuetify/labs/VIconBtn'
import axios from 'axios'
import { computed, ref } from 'vue'
import _uniqBy from 'lodash/uniqBy'
import _uniq from 'lodash/uniq'
import { BaseTree, Draggable, OpenIcon } from '@he-tree/vue'
import '@he-tree/vue/style/default.css'

import showToast from '../shared/show_toast'

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
}

const props = defineProps({
  currentUserId: {
    type: String,
    required: true
  },
  hasAdmin: {
    type: Boolean
  },
  organizationBaseUrl: {
    type: String,
    required: true
  },
  organizations: {
    type: String,
    required: true
  },
  showcases: {
    type: String,
    required: true
  },
  showcaseAlias: {
    type: String,
    required: true
  }
})

const currentUserId = JSON.parse(props.currentUserId)
const hasAdmin = props.hasAdmin
const organizationBaseUrl = props.organizationBaseUrl
const organizations = ref(JSON.parse(props.organizations))
const allShowcasesOfList = ref(JSON.parse(props.showcases))
let beforeOrganizations
let treeKey = 0

const expand = ref(false)

const abilityList = [
  { title: '管理者', value: 'org_admin' },
  { title: '編集者', value: 'org_editor' },
  { title: '閲覧者', value: 'org_member' }
]
const description = ref(null)
const dialog = ref(false)
const errorMessage = ref(null)

const headersForMember  = [
  { title: 'ID', key: 'id' },
  { title: '名前', key: 'name' },
  { title: '祖先権限', key: 'ancestor_role' },
  { title: '権限', key: 'role' },
]
const selectedUserIds = ref([])

const headersForShowcase  = [
  { title: 'ID', key: 'id' },
  { title: 'モデルSID', key: 'sid' },
  { title: '名前', key: 'name' },
]
const selectedShowcaseIds = ref([])

const usersForAdmin = ref([])
if(hasAdmin) {
  axios.get('/admin.json').then(response => {
    usersForAdmin.value = response.data
  })
}

// NOTE: 編集ダイアログの畳まれているUIの自動展開をしたかったらref([0])にする
const panels = ref([])

const lockDraggable = ref(true)
const name = ref(null)
const personnelChangesFile = ref(null)
const registrationFile = ref(null)
const selectedOrganization = ref(null)
const tab = ref('tab-members')
const uploadErrorMessage = ref(null)

const checkDraggable = (stat) => {
  if (hasAdmin) {
    return true
  }
  if (stat.data.root_admin_org_id === stat.data.id) {
    return false
  }
  return stat.data.admin
}

const checkDroppable = (stat) => {
  return stat.data.admin
}

const closeDialog = async () => {
  try {
    const res = await axios.patch(`${organizationBaseUrl}/${selectedOrganization.value.id}`, {
      organization: {
        name: selectedOrganization.value.name,
        description: selectedOrganization.value.description,
        showcase_ids: selectedShowcaseIds.value,
        user_ids: selectedUserIds.value
      },
      user_roles: selectedOrganization.value.users.map(user => {
        return {
          id: user.id,
          role: user.role
        }
      })
    })
    organizations.value = res.data.organizations
    errorMessage.value = null
    dialog.value = false
    showToast(res.data.message)
  } catch (error) {
    errorMessage.value = error.response?.data?.join(',')
  }
}

const createOrganization = async () => {
  let parent_id = null

  try {
    const res = await axios.post(organizationBaseUrl, {
      organization: { name: name.value, description: description.value, parent_id: hasAdmin ? null : selectedRootAdminOrgId.value.value }
    })
    organizations.value = res.data.data
    errorMessage.value = null
    showToast(res.data.message)
  } catch (error) {
    errorMessage.value = error.response?.data?.join(',')
  }
}

const deleteOrganization = async () => {
  const result = confirm('削除しますか？子組織がある場合、子組織は自動的に更に上の組織の子組織になるか、該当組織がない場合は空になります。')
  if (result) {
    try {
      const res = await axios.delete(`${organizationBaseUrl}/${selectedOrganization.value.id}`)
      organizations.value = res.data.data
      selectedOrganization.value = null
      errorMessage.value = null
      dialog.value = false
      showToast(res.data.message)
    } catch (error) {
      errorMessage.value = error.response?.data?.join(',')
    }
  }
}

const downloadFile = (data, filename) => {
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${filename}.csv`)
  document.body.appendChild(link)
  link.click()
}

const downloadPersonnelChanges = async (encoding) => {
  const res = await axios.get(`${organizationBaseUrl}/download_personnel_changes?encoding=${encoding}`, { responseType: 'blob' })
  downloadFile(res.data, 'personnel-changes')
}

const downloadOrganizationTable = async (encoding) => {
  const res = await axios.get(`${organizationBaseUrl}/download_organization_table?encoding=${encoding}`, { responseType: 'blob' })
  downloadFile(res.data, 'organization-table')
}

const downloadOrganizations = async (encoding) => {
  const res = await axios.get(`${organizationBaseUrl}/download_organizations?encoding=${encoding}`, { responseType: 'blob' })
  downloadFile(res.data, 'organizations')
}

const downloadRegistrationTemplate = async (encoding) => {
  const res = await axios.get(`${organizationBaseUrl}/download_registration_template?encoding=${encoding}`, { responseType: 'blob' })
  downloadFile(res.data, 'registration-template')
}

const getParams = (nodes, parentId = null, result = []) => {
  nodes.forEach((node, index) => {
    result.push({ id: node.id, parent_id: parentId, order: index })
    if (node.children?.length > 0) {
      getParams(node.children, node.id, result)
    }
  })
  return result
}

const getRoleName = (role, ancestor_role) => {
  if (ancestor_role === 'org_admin') {
    return '親組織の管理者'
  }
  if (ancestor_role === 'org_editor') {
    return '親組織の編集者'
  }
  if (ancestor_role === 'org_member') {
    return '親組織の閲覧者'
  }
  if (role === 'org_admin') {
    return '管理者'
  }
  if (role === 'org_editor') {
    return '編集者'
  }
  if (role === 'org_member') {
    return '閲覧者'
  }
  return '未所属'
}

const currentRootAdminOrgs = computed(() => {
  const rootAdminOrgIds = []
  const traverseGetrootAdminOrgIds = (org) => {
    rootAdminOrgIds.push(org.root_admin_org_id)
    if (org.children?.length > 0) {
      org.children.forEach(childOrg => traverseGetrootAdminOrgIds(childOrg))
    }
  }
  organizations.value.forEach(org => traverseGetrootAdminOrgIds(org))

  const rootAdminOrgs = []
  _uniq(rootAdminOrgIds).forEach(rootAdminOrgId => {
    const rootAdminOrg = findOrganizationById(organizations.value, rootAdminOrgId)
    if (rootAdminOrg) {
      rootAdminOrgs.push(rootAdminOrg)
    }
  })
  return rootAdminOrgs.map(org => ({ value: org.id, title: org.name }))
})

const findOrganizationById = (orgs, id) => {
  for (const org of orgs) {
    if (org.id === id) {
      return org
    } else if (org.children?.length > 0) {
      const foundOrg = findOrganizationById(org.children, id)
      if (foundOrg) {
        return foundOrg
      }
    }
  }
  return null
}

const handleDragStart = () => {
  beforeOrganizations = JSON.parse(JSON.stringify(organizations.value))
}

const hasAdminOrOrgAdmin = computed(() => {
  if (hasAdmin) {
    return true
  } else {
    const traverse = (org) => {
      if (org.admin) {
        return true
      }
      if (org.children?.length > 0) {
        return org.children.some(childOrg => traverse(childOrg))
      }
      return false
    }
    return organizations.value.some(org => traverse(org))
  }
})

const currentOrgRootSubtreeShowcasesAndUsers = computed(() => {
  const currentOrgId = selectedOrganization.value?.id
  if (!currentOrgId) {
    return { showcases: [], users: [] }
  }

  const showcases = []
  const users = []
  let isCurrentOrgSiblingsSubtree = false

  const traverseSetShowcasesAndUsers = (org) => {
    if (org.id === currentOrgId) {
      isCurrentOrgSiblingsSubtree = true
    }

    org.showcases.forEach(showcase => showcases.push(showcase))
    org.users.forEach(user => users.push({
      id: user.id,
      name: user.name,
      ancestor_role: isCurrentOrgSiblingsSubtree ? 'none' : user.role
    }))

    if (org.children?.length > 0) {
      if (org.children.some(child => child.id === currentOrgId)) {
        isCurrentOrgSiblingsSubtree = true
      }
      org.children.forEach(childOrg => traverseSetShowcasesAndUsers(childOrg))
    }
  }
  traverseSetShowcasesAndUsers(findOrganizationById(organizations.value, selectedOrganization.value.root_admin_org_id))

  if (hasAdmin) {
    usersForAdmin.value.filter(user => !users.some(u => u.id === user.id)).forEach(user => users.push(
      {
        id: user.id,
        name: user.name,
        ancestor_role: 'none'
      }
    ))
    allShowcasesOfList.value.filter(showcase => !showcases.some(s => s.id === showcase.id)).forEach(showcase => showcases.push(showcase))
  }

  return {
    showcases: _uniqBy(showcases, 'id'),
    users: _uniqBy(users, 'id').map(user => ({
      ...user,
      role: selectedOrganization.value.users.find(u => u.id === user.id)?.role || 'none'
    }))
  }
})

const usersRoleModel = (userId) => computed({
  get: () => {
    const user = currentOrgRootSubtreeShowcasesAndUsers.value.users.find(u => u.id === userId)
    return user ? user.role : 'none'
  },
  set: (newRole) => {
    selectedOrganization.value.users.find(u => u.id === userId).role = newRole
  }
})
const onSelectedUserIdsChange = (newSelectedUserIds) => {
  selectedOrganization.value.users = newSelectedUserIds.map(userId => {
    const user = currentOrgRootSubtreeShowcasesAndUsers.value.users.find(u => u.id === userId)
    if (user.role === 'none') {
      user.role = 'org_member'
    }
    return user
  })
}
const onSelectedShowcaseIdsChange = (newSelectedShowcaseIds) => {
  selectedOrganization.value.showcases = newSelectedShowcaseIds.map(showcaseId => {
    return currentOrgRootSubtreeShowcasesAndUsers.value.showcases.find(s => s.id === showcaseId)
  })
}

const showDialog = async (id) => {
  try {
    selectedOrganization.value = findOrganizationById(organizations.value, id)
    selectedUserIds.value = selectedOrganization.value.users.map(user => user.id)
    selectedShowcaseIds.value = selectedOrganization.value.showcases.map(showcase => showcase.id)

    dialog.value = true
  } catch (error) {
    errorMessage.value = error.response?.data?.join(',')
  }
}

const updateRelationships = async () => {
  if (!hasAdmin && beforeOrganizations.length !== organizations.value.length) {
    organizations.value = JSON.parse(JSON.stringify(beforeOrganizations))
    treeKey++
    showToast('ルートの変更権限が無い為、変更を元に戻しました。', 'error')
    return
  }

  if (!hasAdmin) {
    const traverse = (org, parent_id) => {
      if (org.children.length > 0) {
        return org.children.every(child => traverse(child, org.id))
      }

      if (org.root_admin_org_id === org.id) {
        return true
      }

      if (org.root_admin_org_tree_ids.length) {
        return org.root_admin_org_tree_ids.includes(parent_id)
      } else {
        return true
      }
    }
    if (!organizations.value.every(org => traverse(org, null))) {
      organizations.value = JSON.parse(JSON.stringify(beforeOrganizations))
      treeKey++
      showToast('ルート管理組織が違うツリーへの移動は許可されていないため、変更を元に戻しました。', 'error')
      return
    }
  }

  const newRelationships = getParams(organizations.value)
  try {
    const res = await axios.patch(`${organizationBaseUrl}/update_relationships`, {
      new_relationships: newRelationships
    })
    organizations.value = res.data
    errorMessage.value = null
  } catch (error) {
    errorMessage.value = error.response?.data?.join(',')
  }
}

const uploadPersonnelChanges = async () => {
  const file = personnelChangesFile.value
  const formData = new FormData()
  formData.append('file', file)

  try {
    const res = await axios.post(`${organizationBaseUrl}/upload_personnel_changes`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    organizations.value = res.data.data
    personnelChangesFile.value = null
    uploadErrorMessage.value = null
    showToast(res.data.message)
  } catch (error) {
    uploadErrorMessage.value = error.response?.data
  }
}

const uploadRegistration = async () => {
  const file = registrationFile.value
  const formData = new FormData()
  formData.append('file', file)

  try {
    const res = await axios.post(`${organizationBaseUrl}/upload_registration`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    organizations.value = res.data.data
    registrationFile.value = null
    uploadErrorMessage.value = null
    showToast(res.data.message)
  } catch (error) {
    uploadErrorMessage.value = error.response?.data
  }
}

const selectedRootAdminOrgId = ref(currentRootAdminOrgs.value[0])
</script>

<style scoped lang='sass'>
.undraggable
  cursor: not-allowed
  user-select: none
</style>
